import { render, staticRenderFns } from "./Lego.vue?vue&type=template&id=05f7b03b&"
import script from "./Lego.vue?vue&type=script&lang=js&"
export * from "./Lego.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports